/* eslint-disable no-underscore-dangle */
import { Button } from '@salt/components';
import React, { useCallback, useMemo, useState } from 'react';
import Crumbtrail from './Crumbtrail';
import StepProjectName from './StepProjectName';
import ColourPicker from './ColourPicker';
import StepCapabilities from './StepCapabilities';
import StepCategories from './StepCategories';
import StepMembers from './StepMembers';
import { createProject } from '../../../api/users';
// import { useTranslation } from 'react-i18next';
// import { sendBroadcast } from '../../api/broadcast';

const CreateProjectModal = ({ handleCreateProjectModalClose, fetchData, customer }) => {
  const [step, setStep] = useState(0);
  const [project, setProject] = useState({ name: '' });

  const handleCreate = useCallback(() => {
    createProject({
      name: project.name,
      accent_colour: project.accent_colour,
      smart_enabled: project.smart_enabled,
      situational_awareness_enabled: project.situational_awareness_enabled,
      members: project.members.map((m) => m.id),
      categories: project.categories?.split(',').map((c) => Number(c)),
      customer,
    })
      .then(() => {
        fetchData();
      })
      .catch(() => {
        console.error('Failed to delete project');
      });
    handleCreateProjectModalClose();
  }, [project, customer]);

  const noProgress = useMemo(() => {
    if (step === 0) {
      return project.name.trim().length === 0;
    }
    if (step === 1) {
      return !project.accent_colour;
    }
    if (step === 3 && project.smart_enabled) {
      return (
        !project.categories ||
        project.categories.length === 0 ||
        project.categories?.split(',')?.length > 9
      );
    }
    return false;
  }, [step, project, project.smart_enabled]);

  return (
    <div id="dialog" className="overlay z-[100] fixed top-0 left-0 m-auto w-full h-full flex">
      <button
        type="button"
        className="fixed w-full h-full z-[99] bg-black/30"
        onClick={handleCreateProjectModalClose}
      />
      <div className="z-[100] w-[583px] react-modal small bg-secondary-light px-8 py-7 bg-white m-auto rounded-lg">
        <div className="modal-title">
          <h2 className="w-full font-[18px] text-center mb-6">Create New Project</h2>

          <Crumbtrail active={step} projectSmartEnabledDraft={project.smart_enabled && step >= 3} />

          {step === 0 && <StepProjectName project={project} setProject={setProject} />}
          {step === 1 && (
            <ColourPicker
              newColour={project.accent_colour}
              setNewColour={(colour) => setProject({ ...project, accent_colour: colour })}
              description="Choose a colour to identify your Project."
            />
          )}
          {step === 2 && <StepCapabilities project={project} setProject={setProject} />}
          {step === 3 && project.smart_enabled && (
            <StepCategories project={project} setProject={setProject} />
          )}
          {((step === 3 && !project.smart_enabled) || (step === 4 && project.smart_enabled)) && (
            <StepMembers project={project} setProject={setProject} />
          )}

          <div className="mt-4">
            <br />
            <Button
              onClick={handleCreateProjectModalClose}
              type="neutral"
              className="max-w-[146px] h-[36px] ml-auto"
              paddingClassName="px-6"
            >
              Cancel
            </Button>
            <Button
              onClick={
                (step === 4 && project.smart_enabled) || (step === 3 && !project.smart_enabled)
                  ? handleCreate
                  : () => setStep(step + 1)
              }
              type="positive"
              disabled={noProgress}
              className="max-w-[146px] h-[36px] ml-auto float-right"
              paddingClassName="px-6"
            >
              {(step === 4 && project.smart_enabled) || (step === 3 && !project.smart_enabled)
                ? 'Submit'
                : 'Next'}
            </Button>
            {step !== 0 && (
              <Button
                onClick={() => setStep(step - 1)}
                type="positive"
                className="max-w-[146px] h-[36px] ml-auto float-right mx-2"
                paddingClassName="px-6"
              >
                Back
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateProjectModal;
